import { render, staticRenderFns } from "./checklist-tab.vue?vue&type=template&id=59b00714"
import script from "./checklist-tab.vue?vue&type=script&lang=js"
export * from "./checklist-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports